import * as tailwindTextModule from 'bundle-text:./index.css';

const tailwindSheet = new CSSStyleSheet();

tailwindSheet.replaceSync(tailwindTextModule.default || tailwindTextModule);

export default tailwindSheet;


